<div class="base_footer">
    <div class="container-fluid">
        <div class="d-md-flex flex-wrap flex-lg-row justify-content-between align-items-center">
            <div class=" ">
                <div class="footer-text flex-column gap-1">
                    <p class="fw-semibold">Real World Ventures GmbH - Belziger Str. 69-71, 10823 Berlin, Germany.</p>
                </div>
            </div>
                
            <div class="d-flex flex-column flex-md-row gap-md-3">
                <div class="d-flex align-items-center justify-content-lg-center gap-2">
                    <!-- <p><i class="bi bi-envelope-fill fs-6"></i> <a href="mailto:info&#64;realworld.fi">info&#64;realworld.fi</a></p> -->
                    <ul class="social-links">
                        <li><a href="mailto:info&#64;realworld.fi"><i class="bi bi-envelope-fill fs-6"></i></a></li>
                        <li><a href="https://discord.com/invite/6xEX48jsVX" target="_blank" rel="noopener"><em
                                    class="bi bi-discord fs-6"></em></a></li>
                        <li><a href="https://twitter.com/realworld_fi" target="_blank" rel="noopener"><em
                                    class="bi bi-twitter-x fs-6"></em></a></li>
                        <li><a href="https://www.linkedin.com/company/real-world-finance/" rel="noopener"
                                target="_blank"><em class="bi bi-linkedin fs-6"></em></a></li>
                    </ul>
                </div>
                <div class="d-flex align-items-center justify-content-start justify-content-lg-end gap-2">
                    <a href="{{commonService?.docUrls?.privacy_policy_url}}" target="_blank" rel="noopener">Privacy
                        policy.</a>
                    <a>|</a>
                    <a href="{{commonService?.docUrls?.user_agreement_url}}" target="_blank" rel="noopener">Terms & Conditions.</a>
                </div>
            </div>

        </div>
    </div>
    <div class="backtotop" (click)="bottomtotop()">
        <em class="bi bi-arrow-up"></em>
    </div>
</div>